import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeOdin from './pages/Home'
import Callback from './pages/Callback.vue'
import Report from './pages/Report.vue'
import SSRS from './pages/ssrs.vue'
import Tableau from './pages/Tableau.vue'
import TableauEdit from './pages/TableauEdit.vue'
import Admin from './pages/Admin.vue'
import TableauNew from './pages/TableauNew.vue'
import Schema from './pages/Schema.vue'
import GPFile from './pages/GPFile.vue'

Vue.use(VueRouter)

const router = new VueRouter({
    base: __dirname,
    linkActiveClass: 'active',
    mode: 'history',
    routes: [
        { path: '/', component: HomeOdin },
        { path: '/callback', component: Callback },
        { path: '/report', component: Report },
        { path: '/ssrs', component: SSRS },
        { path: '/tableau', component: Tableau },
        { path: '/admin', component: Admin },
        { path: '/tableau2', component: TableauNew },
        { path: '/xapi/:name', component: Schema },
        { path: '/gpfiles', component: GPFile },
        { path: '/customize', component: TableauEdit },
        { path: '*', redirect: '/' }
    ]
})

router.beforeEach((to, from, next) => {
    let title = "E1BI";
    if (to.path == "/") {
        title = "E1BI";
    }
    else {
        if (typeof to.query.path != "undefined") {
            title = "E1BI - " + to.query.path;
        }
    }
    document.title = title;
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router.js